import axios from "axios";

export default function registerAxios(app) {
  app.config.globalProperties.$axios = axios;
}
